'use client';
import { CollectionMetadata as Shared } from '@launchstore/shared-puck';
export const CollectionMetadata: any = Shared;
export default CollectionMetadata;
